// extracted by mini-css-extract-plugin
export default {"list":"SelectPlayground_list__mCwDD"};